
export default {
  name: 'VacancyCardCms',

  props: {
    vacancy: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    openPopup() {
      this.$emit('openVacancyPopup', this.vacancy);
    },
  },
};
